<div [ngClass]="cardGraph ? 'card-container' : 'container'">
  @if (!isForHeader) {
    <h4>
      {{ 'Shell.generic.budgetDeviation' | translate | uppercase }}
      <span [class.greyed-out-text]="cardGraph">({{ title }})</span>
    </h4>
  }

  <div id="values-graph-container">
    <div class="values-container" [ngClass]="[getValuesPadding(), !hasValidDataForAllPoints ? 'centered' : '']">
      @if (hasValidDataForAllPoints) {
        <div>
          {{ maximumValue }}
        </div>
        <div>
          {{ minimumValue }}
        </div>
      } @else {
        {{ 'Shell.generic.na' | translate | uppercase }}
      }
    </div>

    <div id="graph-container">
      <dx-chart [dataSource]="dataSource" [valueAxis]="valueAxis" class="chart">
        <dxo-size [height]="chartHeight" [width]="chartWidth"> </dxo-size>
        <dxo-margin [top]="chartMargin" [bottom]="10" [left]="chartMargin" [right]="chartMargin"> </dxo-margin>
        <dxi-series valueField="target" color="#5bacf5" showInLegend="false">
          <dxo-point size="0" hoverMode="none"></dxo-point>
        </dxi-series>
        <dxi-series valueField="value" showInLegend="false"> </dxi-series>
        <dxo-common-series-settings argumentField="timeSpan" type="line" color="#ffffff">
          <dxo-point size="5" hoverMode="none"></dxo-point>
          <dxo-line hoverMode="none"> </dxo-line>
        </dxo-common-series-settings>
        <dxo-argument-axis [valueMarginsEnabled]="false" [visible]="false">
          <dxo-label [visible]="false"> </dxo-label>
          <dxo-grid [visible]="false"></dxo-grid>
          <dxo-tick [visible]="false"></dxo-tick>
        </dxo-argument-axis>
        <dxo-legend [visible]="false"> </dxo-legend>
      </dx-chart>
    </div>
  </div>
</div>



<div
  class="greyed-out-text clickable link"
  (click)="showDetailsGraph($event)"
  >
  {{ "Shell.general.showGraph" | translate }}
</div>
